function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 128,
    x2: 64,
    y2: 0.000001434923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D4A79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45CAF2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "64,0 8.8,32 8.8,96 64,128 64,128 64,128 119.2,96 119.2,32  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#156AB3",
      stroke: "#0078D4",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "118.8,32.3  118.8,95.8 64,127.5 64,64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D4A79",
      stroke: "#0078D4",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "118.8,32.3  64,64 9.2,32.3 64,0.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#185A97",
      stroke: "#0078D4",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "64,64  64,127.5 9.2,95.8 9.2,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D4A79",
      stroke: "#0078D4",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "9.2,95.8  64,64 64,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#185A97",
      stroke: "#0078D4",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "118.8,95.8  64,64 64,127.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4A79"
    },
    d: "M87.5,66.1C87,66,86.5,66,86,66v0H54.9L64,43.1c0.1,0,0.6,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1l9.6-3.1 c0.3-0.1,0.6-0.3,0.9-0.6l6.3-7l-0.2-2.8l-1.5-1.3l-7.3,8.1l-8,2.6l-5.8-5.2l1.7-8.2l7.3-8.1l-1.5-1.4l-2.8,0.2l-6.3,7 c-0.2,0.3-0.4,0.6-0.5,0.9l-2.1,9.8c-0.1,0.7,0.1,1.4,0.6,1.9c0,0-1,0.3-1.2,0.6L30.1,68.5c-3.3,2.3-5.7,6-6,10.3 c-0.3,3.7,0.9,7.3,3.3,10.2c2.3,2.7,5.4,4.3,8.9,4.8l0,0l47,7.9l0-0.1c0.5,0.1,0.9,0.2,1.4,0.3c0.5,0,1,0.1,1.5,0.1 c9.3,0,17.1-7.1,17.9-16.5C104.8,75.6,97.4,66.9,87.5,66.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M38,92.8c0,0-12.1-3.4-12.1-14.2c0-9.2,12.5-11.3,12.5-11.3L86.9,68 c0,0,15.5,1.8,15.5,16c0,14-15.5,15.9-15.5,15.9L38,92.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    cx: 38,
    cy: 80,
    r: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "58.8,34.9 64.4,38.5 52.6,68.4 33.9,68  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M82,92H90c0.4,0,0.7-0.2,0.9-0.5l4-7c0.2-0.3,0.2-0.7,0-1l-4-7 C90.7,76.2,90.4,76,90,76H82c-0.4,0-0.7,0.2-0.9,0.5l-4,7c-0.2,0.3-0.2,0.7,0,1l4,7C81.3,91.8,81.6,92,82,92z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 4,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 38,
    cy: 80,
    r: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36,84h4c0.2,0,0.3-0.1,0.4-0.3l2-3.5c0.1-0.2,0.1-0.3,0-0.5l-2-3.5C40.4,76.1,40.2,76,40,76h-4 c-0.2,0-0.3,0.1-0.4,0.3l-2,3.5c-0.1,0.2-0.1,0.3,0,0.5l2,3.5C35.6,83.9,35.8,84,36,84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M86,66v4c0.4,0,0.8,0,1.2,0c3.7,0.3,7.1,2,9.5,4.9c2.4,2.9,3.6,6.5,3.3,10.2 C99.4,92.4,93.2,98,86,98c-0.4,0-0.8,0-1.2,0c-3.7-0.3-7.1-2-9.5-4.9c-2.4-2.9-3.6-6.5-3.3-10.2C72.6,75.6,78.8,70,86,70L86,66  M86,66c-9.3,0-17.1,7.1-17.9,16.5c-0.8,9.9,6.6,18.6,16.5,19.4c0.5,0,1,0.1,1.5,0.1c9.3,0,17.1-7.1,17.9-16.5 c0.8-9.9-6.6-18.6-16.5-19.4C87,66,86.5,66,86,66L86,66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M89.5,78l3.5,6l-3.5,6h-6.9l-3.5-6l3.5-6H89.5 M90,76H82c-0.4,0-0.7,0.2-0.9,0.5l-4,7 c-0.2,0.3-0.2,0.7,0,1l4,7c0.2,0.3,0.5,0.5,0.9,0.5H90c0.4,0,0.7-0.2,0.9-0.5l4-7c0.2-0.3,0.2-0.7,0-1l-4-7 C90.7,76.2,90.4,76,90,76L90,76z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 36.5,
    y1: 91.9,
    x2: 83.5,
    y2: 99.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 86,
    y1: 68,
    x2: 38,
    y2: 68
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 4,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M31.6,69.8l24.9-31.9c1-1.2,2.8-1.4,4-0.4l1.2,1.1c0.9,0.7,1.1,1.9,0.7,3L52,68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M82.5,29.5L81,28.1l-7.3,8.1l-8,2.6L60,33.6l1.7-8.2l7.3-8.1 L67.4,16l-2.8,0.2l-6.3,7c-0.2,0.3-0.4,0.6-0.5,0.9l-2.1,9.8c-0.1,0.7,0.1,1.4,0.6,1.9l7.5,6.7c0.4,0.3,0.8,0.5,1.3,0.5 c0.2,0,0.4,0,0.6-0.1l9.6-3.1c0.3-0.1,0.6-0.3,0.9-0.6l6.3-7L82.5,29.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicep);
export default __webpack_public_path__ + "static/media/Bicep.3945ce0be071082bb744e9c75920c6c6.svg";
export { ForwardRef as ReactComponent };